import type { ChatSendTextEventMessageSocket } from "../Models/WebSocket";
import { MessageTypeWebSocket } from "../Models/WebSocket";
import type { ChatStore } from "../Store";
import type { AllChatRoomItemType, CustomChatRoomItem } from "../Models/Domain/Chat";
import { type AllowedChatRoomItemType, ChatRoomItemType, type TextChatRoomItem } from "../Models/Domain/Chat";

import { getNeutral } from "@/Modules/Chat/MessageFilters/helpers/AddNeutralDateEvent";
import { hasValue } from "@/Utils/Objects";

class SendTextMessageActionHandler {
  constructor(private readonly chatStore: ChatStore) {}

  public async handle(chatId: string, text: string): Promise<AllowedChatRoomItemType> {
    return this.sendTextMessageActionHandler(chatId, text);
  }

  private async sendTextMessageActionHandler(chatId: string, text: string): Promise<AllowedChatRoomItemType> {
    return new Promise<AllowedChatRoomItemType>((resolve, reject) => {
      if (!hasValue(this.chatStore.rooms[chatId])) return reject();

      const createdAt = new Date();
      const sendTextEventPayload: ChatSendTextEventMessageSocket = {
        action: "",
        chat: chatId,
        created: createdAt.getTime(),
        etype: 0,
        extra: "",
        nonce: `chat:message:${chatId}:${this.chatStore.rooms[chatId]!.events.length}`,
        private: false,
        text,
        type: MessageTypeWebSocket.CHAT_ROOM_ITEM,
      };
      const event: TextChatRoomItem = {
        id: sendTextEventPayload.nonce,
        old: true,
        createdAt,
        type: ChatRoomItemType.OUTGOING_TEXT,
        text,
        isConfirmed: false,
        isReceived: false,
      };
      const lastNeutralTimeEvent = this.findLastNeutralTimeEvent(this.chatStore.rooms[chatId]!.events);

      if (
        !hasValue(lastNeutralTimeEvent) ||
        !hasValue(lastNeutralTimeEvent.i18nKey) ||
        lastNeutralTimeEvent.i18nKey !== "general.chat.today"
      ) {
        const neutralTimeTexEvent = getNeutral({
          i18nKey: "general.chat.today",
          id: `:${event.id}121-date`,
          createdAt: event.createdAt,
        });
        const newId = `chat:message:${chatId}:${this.chatStore.rooms[chatId]!.events.length + 1}`;

        this.chatStore.rooms[chatId].events.push(neutralTimeTexEvent);
        event.id = newId;
        sendTextEventPayload.nonce = newId;
      }

      this.chatStore.rooms[chatId].events.push(event);
      this.chatStore.socketManager?.sendMessage(sendTextEventPayload);

      resolve(event);
    });
  }

  private findLastNeutralTimeEvent = (events: AllChatRoomItemType[]): CustomChatRoomItem | undefined => {
    for (let i = events.length - 1; i >= 0; --i) {
      if (events[i]!.type === ChatRoomItemType.NEUTRAL_TIME_TEXT) {
        return events[i]! as CustomChatRoomItem;
      }
    }
  };
}

export default SendTextMessageActionHandler;
